import { api } from "./index";

//!-------------------------//
//! --- game api routes --- //
//!-------------------------//

// --- games --- //
export const getGames = () => api.get(`/app/games/get`);
